import { RUSH_ADDRESS_BAR_OPEN, RUSH_ADDRESS_BAR_CLOSED } from '../../actions/shared/ajioRush';

const initialRushAddressBarState = {
    addressBarState: false
};

export const rushAddressBarFlagReducer = (state = initialRushAddressBarState, action) => {
    switch (action.type) {
        case 'RUSH_ADDRESS_BAR_OPEN':
            return {
                addressBarState: true
            };

        case 'RUSH_ADDRESS_BAR_CLOSED':
            return {
                addressBarState: false
            };

        default:
            return state;
    }
}

const initialRushDeliveryTypeData = {
    pdpDeliveryTypeResponse: {
      pdpData: null,
    },
    error: null
  };
  
  export const rushDeliveryTypeReducer = (state = initialRushDeliveryTypeData, action) => {
    switch (action.type) {
      case "RUSH_DELIVERY_TYPE_REQUEST":
        return {
          ...state,
          pdpDeliveryTypeResponse: {
            pdpData: null,
          },
          error: null
        };
  
      case "RUSH_DELIVERY_TYPE_SUCCESS":
        return {
          ...state,
          pdpDeliveryTypeResponse: {
            pdpData: action.payload
          },
          error: null
        };
  
      case "RUSH_DELIVERY_TYPE_FAILURE":
        return {
          ...state,
          pdpDeliveryTypeResponse: {
            pdpData: null
          },
          error: action.payload
        };
  
      default:
        return state;
    }
  };
  